import i18next from 'i18next';

import ManualProductList from '../components/ManualProductList';

import { getCatalogPickerModal } from './getCatalogPickerModal';

/**
 * Fullscreen modal hosting the (modal-agnostic) ManualProductList. Save stays disabled until at
 * least one product is picked. Passing `externalClientId` hides the products already present in
 * that client's catalog, which is what the catalog-administration "Ajouter" action relies on.
 */
export const getManualProductModal = ({
  stores,
  externalClientId = null,
  hasCentralKitchens,
  selectedProductIds,
  onSelectionChange,
  onCancel,
  onConfirm,
}) =>
  getCatalogPickerModal({
    title: i18next.t('EXTERNAL_CLIENTS.CREATION.MANUAL_MODAL_TITLE'),
    icon: '/images/inpulse/add-black-small.svg',
    component: ManualProductList,
    data: {
      stores,
      externalClientId,
      hasCentralKitchens,
      selectedProductIds,
      onSelectionChange,
    },
    isConfirmDisabled: !selectedProductIds.length,
    onCancel,
    onConfirm,
  });
